import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

// Top-level render guard. Any uncaught render/lifecycle throw below this
// boundary shows the fallback panel instead of a blank white screen.
export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="grid min-h-full place-items-center p-6">
        <div className="w-full max-w-lg rounded-lg border border-border bg-panel p-5">
          <h1 className="text-base font-semibold">
            Something broke in the console UI.
          </h1>
          <pre className="mt-3 overflow-x-auto rounded border border-border bg-bg p-3 font-mono text-xs text-danger">
            {error.message}
          </pre>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 rounded border border-border px-3 py-1.5 text-sm hover:bg-bg"
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}
